// theme.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { themeReducer } from './common.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('theme', themeReducer) // Register the feature with the name 'theme'
  ]
})
export class ThemeModule { }
